/**
 * Vuex "subscribe" module (registered as `subscribe` in the root store).
 *
 * Manages a user's follow/following connections: fetching paginated
 * follower/following lists and updating follow state for a user or channel.
 */
import actions from './operations';
import getters from './selectors';
import mutations from './updates';
import state from './store';

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
};
